import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function Rootpavati() {
  const location = useLocation();
  const [studentDetails, setStudentDetails] = useState([]);
  const { amount1, studentSerialNo, fromtheway, thewayup, schoolDetails, allData,newrootdata } = location.state || {};
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem("language");
  const navigate = useNavigate();
console.log("allData",allData);

  const fetchData = async () => {
    const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;

    try {
      const studentResponse = await fetch(studentUrl);
      const studentData = await studentResponse.json();
      console.log("Fetched student data:", studentData);

      if (!studentData || Object.keys(studentData).length === 0) {
        console.warn("No student data found for the given udiseNumber.");
        setStudentDetails([]);
        return;
      }

      const studentArray = Object.values(studentData).filter(student => student !== null && (student.isActive ===true || student.isActive === undefined));
      console.log("studentArray",studentArray);
      
      setStudentDetails(studentArray);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [udiseNumber]);

  

  const matchingStudents = studentDetails.filter(student => {
    console.log("studentSerialNo", studentSerialNo);
    console.log("student", (student.serialNo.toString()));
    
    // Ensure studentSerialNo is a string or array and student.serialNo is correctly checked
    return studentSerialNo && studentSerialNo.includes(student.serialNo.toString());
  });
  
const combinedStudentData = () => {
  const uniqueStudentsMap = new Map();

  // Iterate over the keys of the studentSerialNo object
  Object.entries(newrootdata.studentSerialNo).forEach(([serialNo, isValid]) => {
    if (isValid === true) {
      const student = studentDetails.find(s => s.serialNo === Number(serialNo)); // Ensure to compare with a number
      if (student) {
        uniqueStudentsMap.set(student.serialNo, {
          ...student,
          feeData: allData[student.serialNo] || null,
        });
      }
    }
  });

  return Array.from(uniqueStudentsMap.values()).filter(student => student.serialNo !== null);
};
  const renderCombinedTableRows = () => {
    const students = combinedStudentData();
  
    return students.map(student => {
      const studentFees = student.feeData || {};
      const busFeesArray = Object.values(studentFees)
        .map(fee => fee?.['Bus Fee'])
        .filter(fee => fee)
        .sort((a, b) => (b?.invoiceNo || 0) - (a?.invoiceNo || 0));
  
      let paidFee = 0;
      let discountAmount = 0;
      let beforePay = 0;
      let remainingFee = 0;
  
      if (busFeesArray.length > 0) {
        const latestBusFee = busFeesArray[0];
        beforePay = parseFloat(latestBusFee?.beforePay) || 0;
        paidFee = parseFloat(latestBusFee?.amount) || 0;
        discountAmount = parseFloat(latestBusFee?.discountAmount) || 0;
      }
  
      const feeAmount = newrootdata.amount1; 
  
      return (
        <tr key={student.serialNo}>
          <td style={{border:'1px solid black'}}>{student.currentClass || ' '}</td>
          <td style={{border:'1px solid black'}}>{student.rollNo || ' '}</td>
          <td style={{border:'1px solid black'}}>{student.stdName} {student.stdFather} {student.stdSurname}</td>
          <td style={{border:'1px solid black'}}>{feeAmount}</td>
          <td style={{border:'1px solid black'}}>{discountAmount.toFixed(2)}</td>
          <td style={{border:'1px solid black'}}>{(feeAmount - discountAmount).toFixed(2)}</td> 
          <td style={{border:'1px solid black'}}>{beforePay.toFixed(2)}</td>
          <td style={{border:'1px solid black'}}>{(feeAmount  - beforePay).toFixed(2)}</td> 
        </tr>
      );
    });
  };
  
  
  
  
  const handlePrint = () => {
    const printContent = document.querySelector('.receipt-container');
    const printWindow = window.open('', '', 'height=600,width=800');

    printWindow.document.write(`
      <html>
        <head>
        
          <style>
            body {
              font-family: Arial, sans-serif;
              border: 2px solid black;
              padding: 10px;
            }
                 @page {
             size: A4 Portrait;
            margin: 3mm; /* this affects the margin in the printer settings */
          }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
               border: 1px solid black;
            }
            th, td {
              border: 1px solid black;
              padding: 8px;
              text-align: center;
            }
            th {
              background-color: #A31D27;
              color: white;
               border: 1px solid black;
            }
            .receipt-header {
              text-align: center;
              margin-bottom: 20px;
            }
            .taludis {
              text-align: left;
            }
            .receipt-header h1 {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .receipt-header h2 {
              font-size: 20px;
              margin-bottom: 10px;
            }
            .receipt-header h3 {
              font-size: 14px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            h1, h2 {
              text-align: center;
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };

  console.log('studentSerialNo:', newrootdata.studentSerialNo);
  return (
    <div className='main-content-of-page'>
  <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }}>
    <button 
      onClick={handleGoBack} 
      style={{
        backgroundColor: '#FFFFFF',
        color: 'black',
        padding: '7px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginRight: '20px', // Space between buttons
        border: '1px solid black',
        marginTop: '20px',
        marginLeft: '30px',
      }}
    >
      <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
      Go Back
    </button>
    
    <button 
      onClick={handlePrint} 
      style={{
        backgroundColor: '#A31D27',
        color: 'white',
        padding: '10px 20px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginTop: '20px',
      }}
    >
      Print Report
    </button>
  </div>

  <div className="receipt-container">
    <div className="receipt-header" style={{border: '1px solid black', marginBottom: '10px', backgroundColor: '#F7F7F7', padding: '10px'}} >
      <h8>{schoolDetails?.sansthaName || ' '}</h8>
      <h1>{schoolDetails?.schoolName || ' '}</h1>
      <div className='taludis' style={{textAlign: 'center'}}>
        <h8>{language === "English" ? "Taluka:  " : "तालुका"}: {schoolDetails?.taluka},  {language === "English" ? "District: " : "जिल्हा"}: {schoolDetails?.jilha}</h8>
      </div>
      <h2 style={{
        display: 'block',
        border: '1px solid black',
        backgroundColor: 'black',
        color: 'white',
        padding: '5px',
        width: '200px',
        textAlign: 'center',
        margin: '10px auto',
        borderRadius: '10px'
      }}>{language === "English" ? "Root Wise Report  " : "मार्गानुसार अहवाल"}</h2>
    </div>

    <p style={{ fontSize: '15px', marginBottom: '16px' }}>
      <strong>{language === "English" ? "Root:  " : "मार्ग"}</strong> {fromtheway} {language === "English" ? "To:  " : "ते"} {thewayup}
    </p>
    
    {/* Render Root Data Table only if matching students are found */}
    {matchingStudents.length > 0 && (
      <>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={headerStyle}>{language === "English" ? "Class  " : "वर्ग"}</th>
              <th style={headerStyle}>{language === "English" ? "Roll No  " : "रोल नंबर"}</th>
              <th style={headerStyle}>{language === "English" ? "Name  " : "नाव"}</th>
              <th style={headerStyle}>{language === "English" ? "Fee  " : "फी"}</th>
              <th style={headerStyle}>{language === "English" ? "Discount (RS)  " : "सवलत (RS)"}</th>
              <th style={headerStyle}>{language === "English" ? "After Discount Fee  " : "सवलत फी नंतर"}</th>
              <th style={headerStyle}>{language === "English" ? "Paid Fee  " : "दिलेली फी"}</th>
              <th style={headerStyle}>{language === "English" ? "Remaining Fee  " : "उर्वरित फी"}</th>
            </tr>
          </thead>
          <tbody>
            {renderCombinedTableRows().length > 0 ? renderCombinedTableRows() : (
              <tr>
                <td colSpan={10} style={{ fontSize: '14px', color: 'red' }}>{language === "English" ? "No matching students found. " : "जुळणारे विद्यार्थी आढळले नाहीत."}</td>
              </tr>
            )}
          </tbody>
        </table>
      </>
    )}
  </div>
</div>
  );
}

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  marginBottom: '20px',
};

const headerStyle = {
  backgroundColor: '#A31D27',
  color: 'white',
  textAlign: 'center',
  padding: '10px',
  border: '1px solid black',
};

export default Rootpavati;
